export class StoredValue {
    storage: Storage;
    storage_key: string;
    value: any | any[];

    constructor(storage, storage_key, initial_value = null, initial_save = false) {
        this.storage = storage;
        this.storage_key = storage_key;
        this.value = initial_value;

        if (this.storage && this.storage.getItem(this.storage_key)) {
            // load from storage
            this.load();
        } else {
            if (initial_save) {
                this.save();
            }
        }
    }

    save() {
        this.storage.setItem(this.storage_key, JSON.stringify(this.value));
    }

    load() {
        this.value = JSON.parse(this.storage.getItem(this.storage_key));
    }
}

export class StoredSet extends StoredValue {
    /* JSON do not support sets, so I emmulate basic Set functionality on arrays */

    add(quote_id) {
        this.value.push(quote_id);
        this.save();
    }

    delete(quote_id) {
        this.value = this.value.filter(function (e) {
            return e !== quote_id;
        });
        this.save();
    }

    has(quote_id) {
        return this.value.indexOf(quote_id) !== -1;
    }
}
